(function () {
  'use strict';

  function initSponsorsCarousel(el) {
    if (!el || typeof Swiper === 'undefined') {
      return;
    }

    var offsetX = el.clientWidth || 0;
    var carouselBlazy;
    if (typeof Blazy !== 'undefined') {
      carouselBlazy = new Blazy({
        offset: offsetX
      });
    } else {
      carouselBlazy = { revalidate: function () {} };
    }

    var sponsorCount = parseInt(el.getAttribute('data-sponsor-count'), 10) || 0;
    var enableAutoplay = sponsorCount > 4;

    var swiperOptions = {
      slidesPerView: 1,
      slidesPerGroup: 1,
      speed: 1000,
      loop: enableAutoplay,
      watchOverflow: !enableAutoplay,
      centerInsufficientSlides: !enableAutoplay
    };

    if (enableAutoplay) {
      swiperOptions.autoplay = {
        delay: 3000,
        disableOnInteraction: false
      };
    }

    var swiper = new Swiper(el, Object.assign(swiperOptions, {
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      },
      grabCursor: true,
      breakpoints: {
        430: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        600: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        800: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        950: {
          slidesPerView: 'auto',
          slidesPerGroup: 1
        }
      },
      on: {
        slideChange: function () {
          carouselBlazy.revalidate();
        },
        resize: function () {
          carouselBlazy.revalidate();
        }
      }
    }));

    return swiper;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('[data-sponsors-carousel]');
    carousels.forEach(function (el) {
      initSponsorsCarousel(el);
    });
  });
})();
